import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useEffect, useRef } from 'react';
import { SearchInput } from '@ui/general';
export const TextFilter = (props) => {
    const searchRef = useRef(null);
    useEffect(() => {
        var _a;
        if (searchRef.current) {
            searchRef.current.setText((_a = props.value) !== null && _a !== void 0 ? _a : '');
        }
    }, [props.value]);
    const { format, id, label, onChange, placeholder, value } = props;
    return (React.createElement(FilterComponent, Object.assign({}, props),
        React.createElement(SearchInput, { className: 'filter', defaultValue: value, id: getFilterId(id), onChange: (query = '') => onChange({
                [id]: {
                    format,
                    value: query
                }
            }), placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : PLACEHOLDERS_COPY.FILTER_BY(capitalize(label !== null && label !== void 0 ? label : '')), ref: searchRef })));
};
